import HomePage from "./components/page/HomePage";
import {createRouter, createWebHistory} from "vue-router";
import InfoPage from "./components/page/InfoPage";
import Products from "./components/page/Products";
import Product from "./components/page/Product";
import store from "./store";
import ShoppingChart from "./components/page/ShoppingChart";
import Login from "./components/page/Login";
import Register from "./components/page/Register";
import ContactUs from "./components/page/ContactUs";
import Profile from "./components/page/Profile";
import {getMe} from "./repositories/UserRepository";
import cookie from "js-cookie";
import OrderPage from "./components/page/OrderPage";
import Payment from "./components/page/Payment";
import ProfileHome from "./components/page/ProfileHome";
import MyOrdersPage from "./components/page/MyOrdersPage";
import NotFoundPage from "./components/page/NotFoundPage";
import MyFavorites from "./components/page/MyFavorites";
import MyViewHistory from "./components/page/MyViewHistory";
import MyAddresses from "./components/page/MyAddresses";
import Brands from "./components/page/Brands";
import Catalogs from "./components/page/Catalogs";
import SearchResults from "./components/page/SearchResults";
import Gallery from "./components/page/Gallery";


const router = createRouter({
        history: createWebHistory(),
        // eslint-disable-next-line no-unused-vars
        scrollBehavior(to, from, savedPosition) {
            return {
                x: 0, y: 0,
                behavior: 'smooth'
            }
        },
        routes: [
            {'path': '/', component: HomePage},
            {'path': '/search', component: SearchResults},
            {'path': '/page/:slug', component: InfoPage},
            {
                'name': 'category',
                'path': '/category/:slug', component: Products, props: route => ({
                    pageType: "category",
                    categorySlug: route.params.slug
                })
            }, {
                'path': '/product/:slug', component: Product
            },
            {'path': '/brands', component: Brands},
            {'path': '/catalogs', component: Catalogs},
            {'path': '/contact', component: ContactUs},
            {'path': '/branch', component: HomePage},
            {'path': '/gallery', component: Gallery},
            {
                'name': 'products',
                'path': '/products',
                component: Products
            },
            {'path': '/cart', component: ShoppingChart},
            {
                'path': '/login', component: Login, beforeEnter: (to, from, next) => {
                    if (store.state.auth.token !== null && store.state.auth.token !== "null") {
                        next('/profile');
                    } else {
                        next();
                    }
                }
            },
            {
                'path': '/register', component: Register, beforeEnter: (to, from, next) => {
                    if (store.state.auth.token !== null && store.state.auth.token !== "null") {
                        next('/profile');
                    } else {
                        next();
                    }
                }
            },
            {
                'path': '/profile', component: Profile, beforeEnter: async (to, from, next) => {
                    if (store.state.auth.token !== null && store.state.auth.token !== "null") {
                        await getMe(store.state.auth.token).then(data => {
                            if (data.code === 200) {
                                next();
                            } else if (data.code === 401) {
                                cookie.set('token', null);
                                next('/login');
                            } else {
                                next('/');
                            }

                        })

                    } else {
                        next('/login');
                    }
                }, children: [
                    {
                        'path': '', component: ProfileHome
                    },
                    {
                        'path': 'orders', component: MyOrdersPage
                    },
                    {
                        'path': 'order/:id', component: OrderPage
                    },
                    {
                        'path': 'favorites', component: MyFavorites
                    },
                    {
                        'path': 'addresses', component: MyAddresses
                    },
                    {
                        'path': 'viewHistory', component: MyViewHistory
                    },
                ]
            },

            {
                'path': '/payment/:id', component: Payment
            },
            {
                path: "/notFound", component: NotFoundPage
            },

            {
                path: "/:catchAll(.*)", component: NotFoundPage
            }

        ]
    }
);

router.beforeEach(() => {
    store.commit('app/setAppDrawer', false);
    store.commit('app/setTaxIncluded', localStorage.getItem('taxIncluded') > 0);

})

export default router;